import React from "react";
import { useEmpresaSelector } from "../context/EmpresaSelectorContext";

export default function EmpresaBadge() {
  const { empresaSeleccionada, esConexAdmin } = useEmpresaSelector();

  if (!esConexAdmin) return null;

  return (
    <div className="notification is-info is-light" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span className="icon" style={{ marginRight: 6 }}>
        <i className="fas fa-building"></i>
      </span>
      <span>
        <strong>Visualizando datos de:</strong> {empresaSeleccionada?.nombre || 'Todas las empresas'}
      </span>
    </div>
  );
}
